import { FormikProps } from "formik";
import ValidationErrorMessage from "./ValidationErrorMessage";
import IsRequired from "./common/IsRequired";

export function FormikTextArea<U>(props: {
  config: ITextAreaEdit<U>;
  formik: FormikProps<any>;
  disabled?: boolean;
}) {
  const { config, formik, disabled } = props;
  const { label, id, placeholder, isRequired, rows } = config;
  return (
    <>
      <label className="form-label" htmlFor={id}>
        {label}
        {isRequired && <IsRequired />}
      </label>
      <textarea
        disabled={disabled}
        placeholder={`${placeholder ? `${placeholder}` : ""}`}
        className={`form-control ${
          formik.touched[id] && (formik as any).errors[id] ? "is-invalid" : ""
        }`}
        id={id}
        rows={rows ? rows : 2}
        value={formik.values[id] ?? ""}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      ></textarea>
      <ValidationErrorMessage
        touched={formik.touched[id]}
        errorMessage={(formik as any).errors[id]}
      />
    </>
  );
}
